module.exports = __webpack_public_path__ + "img/Warum.02bf2e2d.jpg";